import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/accessInput/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_jw6qn_1",
  "input": "_input_jw6qn_5",
  "openedInput": "_openedInput_jw6qn_22",
  "iconOpen": "_iconOpen_jw6qn_28",
  "iconClose": "_iconClose_jw6qn_39",
  "listRoot": "_listRoot_jw6qn_47",
  "list": "_list_jw6qn_47",
  "role": "_role_jw6qn_1",
  "textHidden": "_textHidden_jw6qn_71",
  "selectedRole": "_selectedRole_jw6qn_76",
  "selectedRoleIcon": "_selectedRoleIcon_jw6qn_80",
  "selectedRoleTitle": "_selectedRoleTitle_jw6qn_86",
  "roleDescription": "_roleDescription_jw6qn_93",
  "selectedRoles": "_selectedRoles_jw6qn_98"
};